import SavedListPage from "./SavedListPage";

export default SavedListPage;